module.exports = __webpack_public_path__ + "img/icon_pool.47501ca3.png";